const state = {}

const getters = {}

const mutations = {}

const actions = {}

export function prepareAmosMetadata(context) {
  context.commit('setFeatures', { amos: { category: 'amos' } })
}

export default {
  state,
  getters,
  mutations,
  actions,
}
